export default {
  data() {
    return {
      category: [{
        name: "Роллы",
        path: "rolls",
        imgUrl: require("@/img/category/category-1.svg"),
        imgPath: require("@/img/category/category-21.svg")
      }, {
        name: "Суши",
        path: "sushi",
        imgUrl: require("@/img/category/category-2.svg"),
        imgPath: require("@/img/category/category-11.svg")
      }, {
        name: "Сеты",
        path: "sets",
        imgUrl: require("@/img/category/category-3.svg"),
        imgPath: require("@/img/category/category-31.svg")
      }, {
        name: "Боулы",
        path: "snacks",
        imgUrl: require("@/img/category/category-4.svg"),
        imgPath: require("@/img/category/category-41.svg")
      }, {
        name: "Напитки",
        path: "drinks",
        imgUrl: require("@/img/category/category-5.svg"),
        imgPath: require("@/img/category/category-51.svg")
      }, {
        name: "Соусы",
        path: "rollsq",
        imgUrl: require("@/img/category/category-6.svg"),
        imgPath: require("@/img/category/category-61.svg")
      }, {
        name: "",
        path: "",
        imgUrl: ""
      }, {
        name: "",
        path: "",
        imgUrl: ""
      }]
    };
  },
  props: {}
};